/**
 * ANOK Contact Form — 3-screen flow (Input -> Confirmation -> Submission)
 */
(function() {
  'use strict';

  var inputView = document.getElementById('anok-contact-input');
  var confirmView = document.getElementById('anok-contact-confirm');
  var confirmBtn = document.getElementById('anok-confirm-btn');
  var backBtn = document.getElementById('anok-back-btn');

  if (!inputView || !confirmView || !confirmBtn || !backBtn) return;

  var form = inputView.closest('form');
  if (!form) return;

  /**
   * Validate required fields using native constraint validation.
   * @returns {boolean}
   */
  function validateForm() {
    var requiredInputs = form.querySelectorAll('[required]');
    for (var i = 0; i < requiredInputs.length; i++) {
      if (!requiredInputs[i].checkValidity()) {
        requiredInputs[i].reportValidity();
        return false;
      }
    }
    var radioChecked = form.querySelector('input[name="contact[inquiry_type]"]:checked');
    if (!radioChecked) {
      var firstRadio = form.querySelector('input[name="contact[inquiry_type]"]');
      if (firstRadio) firstRadio.reportValidity();
      return false;
    }
    return true;
  }

  /**
   * Set a confirmation field's text content.
   * @param {string} field - data-confirm-field value
   * @param {string} value - display value
   */
  function setConfirmValue(field, value) {
    var el = confirmView.querySelector('[data-confirm-field="' + field + '"]');
    if (!el) return;
    if (el.classList.contains('anok-contact-form__confirm-value--multiline')) {
      el.innerHTML = escapeHtml(value).replace(/\n/g, '<br>');
    } else {
      el.textContent = value;
    }
  }

  /**
   * Escape HTML special characters.
   * @param {string} str
   * @returns {string}
   */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /**
   * Populate confirmation view with current form values.
   */
  function populateConfirmation() {
    var nameInput = form.querySelector('[name="contact[name]"]');
    var emailInput = form.querySelector('[name="contact[email]"]');
    var phoneInput = form.querySelector('[name="contact[phone]"]');
    var radioChecked = form.querySelector('input[name="contact[inquiry_type]"]:checked');
    var bodyInput = form.querySelector('[name="contact[body]"]');

    setConfirmValue('name', nameInput ? nameInput.value : '');
    setConfirmValue('email', emailInput ? emailInput.value : '');
    setConfirmValue('phone', phoneInput ? phoneInput.value : '');
    setConfirmValue('inquiry_type', radioChecked ? radioChecked.value : '');
    setConfirmValue('body', bodyInput ? bodyInput.value : '');

    // Hide phone field row if empty (optional field)
    var phoneField = document.getElementById('anok-confirm-phone-field');
    if (phoneField) {
      phoneField.hidden = !(phoneInput && phoneInput.value.trim());
    }
  }

  /**
   * Scroll to the top of the form section.
   */
  function scrollToSection() {
    var section = form.closest('.anok-contact-form');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Input -> Confirmation
  confirmBtn.addEventListener('click', function() {
    if (!validateForm()) return;
    populateConfirmation();
    inputView.hidden = true;
    confirmView.hidden = false;
    scrollToSection();
  });

  // Confirmation -> Input (back)
  backBtn.addEventListener('click', function() {
    confirmView.hidden = true;
    inputView.hidden = false;
    scrollToSection();
  });
})();
